import React, { useEffect } from 'react'
import ComingSoon from '../comingSoon/comingSoon'
import { useLocation } from 'react-router-dom';

const ComingSoonPage = (props) => {

    const pathname = useLocation();
    // const { pageName } = pathname.state || {};
    // useEffect(() => {
    //     window.scrollTo(0, 0);
    // }, [])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return (
        <ComingSoon pageName={props.pageName} />
    )
}

export default ComingSoonPage